document.addEventListener("DOMContentLoaded", (event) => {
  const navigationBar = document.querySelector('#navigation-bar');
  const customNavigationOverlay = document.querySelector('#custom-navigation-overlay');
  const customNavigation = document.querySelector('#custom-navigation');
  const closeBtns = customNavigation.querySelectorAll('svg.icon-close');
  const backBtns = customNavigation.querySelectorAll('span.back-btn');
  const allLinksWithChild = customNavigation.querySelectorAll('a[data-has-child]');
  
  navigationBar.addEventListener('click', () => {
    customNavigation.classList.add('active');
    customNavigation.setAttribute('aria-expanded', true);
  });

  const closeNavigation = () => {
    customNavigation.classList.remove('active');
    customNavigation.setAttribute('aria-expanded', false);
  }
  
  customNavigationOverlay.addEventListener('click', closeNavigation);
  
  closeBtns.forEach(btn => {
    btn.addEventListener('click', closeNavigation);
  })

  backBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const subContent = btn.closest('.navigation-subcontent');
      subContent.classList.remove('active');
    });
  });

  allLinksWithChild.forEach(link => {
    link.onclick = (e) => {
      e.preventDefault();
      const subContent = link.parentElement.querySelector(':scope > .navigation-subcontent');

      if (!subContent.classList.contains('active'))
        subContent.classList.add('active');
    };
  });

  new Swiper('#custom-navigation .swiper', {
    slidesPerView: 'auto',
    spaceBetween: 20
  });
});


// CUSTOM BUNDLE PICKER
document.addEventListener("DOMContentLoaded", (event) => {
  const actionSubmitButtons = document.querySelectorAll('.dave-bar-action');
  
  // Get the cart drawer element
  const cartDrawer = document.querySelector('#cart-drawer');
      console.log("actionSubmitButtons" ,actionSubmitButtons)
  // Loop through each 'action-submit' element and add a click event listener
  actionSubmitButtons.forEach(button => {
    button.addEventListener('click', () => {
      console.log("click")
      if (cartDrawer.hasAttribute('open')) {
        cartDrawer.removeAttribute('open');
      } else {
        cartDrawer.setAttribute('open', '');
      }
    });
  });
});


class CardSwitch extends HTMLElement {
  connectedCallback() {
    console.log("CardSwitch connected!");

    // Observe changes in the custom element
    const observer = new MutationObserver(() => this.attachListeners());
    observer.observe(this, { childList: true, subtree: true });

    // Initial call in case inputs are already present
    this.attachListeners();
  }

  attachListeners() {
    const inputs = this.querySelectorAll('input');
    console.log(`Found ${inputs.length} inputs`);

    if (!inputs.length) {
      console.error("No inputs found in CardSwitch!");
      return;
    }

    inputs.forEach(input => {
      input.addEventListener('change', (e) => this.handleSelection(e.target));
    });
  }


  handleSelection(selectedInput) {
    console.log("Input selected:", selectedInput);

    const selectedLabel = this.querySelector(`label[for="${selectedInput.id}"]`);
    if (!selectedLabel) {
      console.error("No label found for input:", selectedInput);
      return;
    }

    // Deselect all other inputs in the fieldset
    this.querySelectorAll('input').forEach(input => {
      input.checked = input === selectedInput;
    });

    const productCard = this.closest('product-card');
    console.log("pCard",productCard)
    const cardSwitch = productCard.querySelector('.card_switch');
    if (!cardSwitch) {
      console.error("No .card_switch found!");
      return;
    }

    const images = cardSwitch.querySelectorAll('.product-card__image--switch');
    const selectedVariantId = selectedLabel.getAttribute('data-variant-id');
    if (!selectedVariantId) {
      console.error("No data-variant-id found on label:", selectedLabel);
      return;
    }
    
    images.forEach(image => {
      console.log("image", image, image.getAttribute('data-id'), selectedVariantId)
      image.classList.toggle('show', image.getAttribute('data-id') === selectedVariantId);
    });
  }
}

customElements.define('card-switch', CardSwitch);





